import { useRouter } from 'next/router';

export function useGetSessionId(): string {
  const router = useRouter();

  return Array.isArray(router.query['session-id']) ? router.query['session-id'][0] : router.query['session-id'] ?? '';
}
